import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
  container: {
    padding: `${theme.spacing(3)}!important`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
